import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IconContext } from "react-icons/lib";
import { NavBarContainer, UserDropDown } from "styles/components/NavBar";
import AccountDropDown from "components/AccountDropDown";
import HeaderLogo from "assets/svg/Logo";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Notifications from "pages/notifications";
import { useText } from "locales/useGetText";
const NavBar = (props) => {
  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const locale = useText("nav");
  const [dropdownMenu, setDropdownMenu] = useState(false);
  const handleDropDownClick = () => setDropdownMenu(!dropdownMenu);

  return (
    <IconContext.Provider value={{ color: "#fff" }}>
      <NavBarContainer>
        <nav className="navbar">
          <div className="nav-wrapper">
            <div className="navbar-container">
              <Link
                to="/dashboard"
                className="navbar-logo"
              >
                <HeaderLogo />
                {/* <img src={headerLogo} className="logo" alt="headerLogo" /> */}
              </Link>

              <ul
                className={`${"nav-menu active"}`}
              >
                <li className={`nav-item ${props?.activeTab === "Dashboard" &&
                  "active"
                  }`}>
                  <Link
                    to="/dashboard"
                    className=""
                  >
                    {locale('dashboard')}
                  </Link>
                </li>
                <li className={`nav-item ${props?.activeTab === "RequestOrder" &&
                  "active"
                  }`}>
                  <Link
                    to="/request-orders"
                    className=""
                  >
                     {locale('requestOrders')}
                  </Link>
                </li>
                <li className={`nav-item ${props?.activeTab === "RequestPickUpOrder" &&
                  "active"
                  }`}>
                  <Link
                    to="/request-pickup-orders"
                    className=""
                  >
                    {locale('requestPickup')}
                  </Link>
                </li>
                <li className={`nav-item ${props?.activeTab === "ManageOrder" &&
                  "active"
                  }`}>
                  <Link
                    to="/manage-orders"
                    className=""
                  >
                    {locale('manageOrders')}
                  </Link>
                </li>
                <li className={`nav-item ${props?.activeTab === "Invoice" &&
                  "active"
                  }`}>
                  <Link
                    to="/invoices"
                    className=""
                  >
                   {locale('invoiceRemits')}
                  </Link>
                </li>
              </ul>

              <ul
                className={`${"right-menu"}`}
              >
                <li className="nav-item event-li">
                  <Notifications />
                </li>
                <li
                  className="nav-item web-view"
                >
                  <div className="nav-link user-name" onClick={() => handleDropDownClick()}>
                    <div className="upper-name">
                      <p title={loggedInUserInfo?.name}>{loggedInUserInfo?.name}</p>
                      <ExpandMoreIcon style={{ color: "inherit" }} />
                    </div>
                    {/* <span>PTPlus Admin</span> */}
                  </div>
                  {dropdownMenu && (
                    <AccountDropDown />
                  )}
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </NavBarContainer>
    </IconContext.Provider>
  );
};

export default NavBar;
